import { Button, DatePicker, Input, Select } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FiCheck, FiEye } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import { socket } from "@/api/socket";
import appConfig from "@/config/appConfig";
import { DataTable } from "@/components";
import { userRole, userRoleFormate } from "@/constant/userRole";
import { exportCSV } from "@/utils/exportCsv";
import LoadingOverlay from "@/components/Shared/LoadingOverlay";
import { flare } from "@flareapp/js";

const { RangePicker } = DatePicker;

const AlarmHistory = () => {
  const [searchParams] = useSearchParams();
  const userDetails = useSelector((state) => state?.user?.userDetails);

  // const options = {
  //   orientation: "landscape",
  //   unit: "in",
  //   format: [11.69, 8.27],
  // };
  const [businessList, setBusinessList] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [siteLocations, setSiteLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState({
    site: undefined,
    from: searchParams.get("startDate") ? searchParams.get("startDate") : "",
    to: searchParams.get("endDate") ? searchParams.get("endDate") : "",
    ackow: searchParams.get("ackow") || "",
  });
  const { site, from, to, business } = filter;

  const onSearch = (e) => {
    const text = e.target.value;
    setPage(1);
    setSearch(text);
  };

  const getBusiness = async () => {
    try {
      const data = await api.get(endpoint.business);
      setBusinessList(data?.data || []);
      if (data?.data?.length === 1) {
        setFilter((prev) => ({ ...prev, business: data.data[0]?._id }));
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("business list", error);
    }
  };

  const getNotificationHistory = async () => {
    setIsLoading(true);
    try {
      let { results, count } = await api.get(endpoint.notification_history, {
        params: {
          limit,
          page,
          sortBy: "date",
          orderBy: "DESC",
          search,
          ...filter,
        },
        withCredentials: true,
      });
      setNotifications(results);
      setTotal(count || 0);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("notification history", error);
    }
    setIsLoading(false);
  };

  const getSiteLocations = async () => {
    try {
      const response = await axios.get(`/site-location/my-site`, {
        params: { business: business ? [business] : "", limit: 100000 },
        withCredentials: true,
      });
      if (response) {
        let data = response.data;
        setSiteLocations(data);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site location list", error);
    }
  };

  useEffect(() => {
    getBusiness();
  }, []);
  useEffect(() => {
    getSiteLocations();
  }, [business]);

  useEffect(() => {
    document.title = `${appConfig.name} - Alarm Trigger History`;
    getNotificationHistory();
  }, [page, limit, filter, search]);

  const updateAcknowledgedBy = async (id) => {
    setIsLoading(true);
    try {
      Swal.fire({
        title: "Do you wish to?",
        text: "Mark this notification as acknowledged?",
        //icon: "warning",
        dangerMode: true,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        if (result.isConfirmed) {
          api
            .put(endpoint.notification_history, {
              acknowledgedBy: userDetails._id,
              id,
            })
            .then(() =>
              Swal.fire({
                icon: "success",
                text: "Alarm marked as Acknowledged",
                timer: 1000,
                confirmButtonText: "OK",
              }),
            )
            .catch(() =>
              Swal.fire({
                icon: "error",
                text: "Error Happened",
                timer: 1000,
                confirmButtonText: "OK",
              }),
            );
        }
      });

      await getNotificationHistory();
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("acknowledge notification", error);
    }
    setIsLoading(false);
  };
  const columns = [
    {
      title: "No.",
      render: (row, _, index) => (page - 1) * limit + index + 1,
      width: "60px",
      align: "center",
    },
    {
      title: "Alarm Name",
      render: (row) => <div>{row?.notification?.name}</div>,
    },
    {
      title: "Site Name",
      render: (row) => <>{row?.site?.name}</>,
    },
    {
      title: "Device Name",
      render: (row) => row?.device?.name,
      width: "150px",
    },
    {
      title: "Parameter",
      render: (row) => row?.parameter?.name,
      align: "center",
    },
    // {
    //     title: "Trigger Status",
    //     // render: (row) => row?.parameter?.name,
    // },
    {
      title: "Trigger Value",
      render: (row) => row?.value,
      align: "center",
    },
    {
      title: "Acknowledged By",
      render: (row) => (
        <div>
          <div className="mb-1">{row?.acknowledgedBy?.name ? row?.acknowledgedBy?.name : ""}</div>
          <div>{row?.acknowledgedBy ? dayjs(row?.updatedAt).format("DD/MM/YYYY hh:mm:ss a") : ""}</div>
        </div>
      ),
      grow: 2.2,
      // hidden: userDetails?.role === userRole.public,
    },
    {
      title: "Timestamp",
      render: (row) => (
        <div className="text-md-center">
          {dayjs(row?.createdAt).format("DD/MM/YYYY")}
          <br />
          {dayjs(row?.createdAt).format("hh:mm:ss a")}
        </div>
      ),
    },
    {
      title: "Action",
      render: (row) => (
        <div>
          {row?.acknowledgedBy || userDetails?.role === userRole.public ? (
            ""
          ) : (
            <button className="btn btn-warning me-2" onClick={() => updateAcknowledgedBy(row?._id)}>
              <FiCheck />
            </button>
          )}
          <Link to={`/alarm-view/` + row?.notification?._id} title="View Alarm" className="btn btn-az-primary me-1">
            <FiEye />
          </Link>
        </div>
      ),
      width: "150px",
      align: "center",
    },
  ].filter(({ hidden }) => !hidden);

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current.valueOf() > new Date();
  };

  // Bulk download CSV with all records
  const handleBulkDownloadCSV = async () => {
    try {
      // Generate a unique session ID for tracking this download
      const sessionId = `download_alarm_history_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

      // Show persistent processing toast
      Swal.fire({
        icon: "info",
        title: "Preparing Your Report",
        text: "Please wait while we prepare your download...",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Setup Socket.IO listener for progress updates
      const handleProgressUpdate = (data) => {
        if (data.sessionId === sessionId && data.type === "bulk_download_progress") {
          if (data.status === "processing") {
            // Update the existing toast with progress
            Swal.update({
              icon: "info",
              title: "Preparing Your Report",
              text: `Processing ${data.totalRecords?.toLocaleString() || 0} records...`,
            });
          } else if (data.status === "completed") {
            // Remove the listener
            socket.off("messageResponse", handleProgressUpdate);

            // Close the processing toast and show success message
            Swal.close();

            Swal.fire({
              icon: "success",
              title: "Download Complete!",
              text: `Successfully downloaded ${data.totalRecords?.toLocaleString() || 0} records`,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else if (data.status === "error") {
            // Remove the listener
            socket.off("messageResponse", handleProgressUpdate);

            // Close the processing toast and show error
            Swal.close();

            Swal.fire({
              icon: "error",
              title: "Download Failed",
              text: "Unable to complete the download. Please try again.",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          }
        }
      };

      socket.on("messageResponse", handleProgressUpdate);

      // Fetch all records without pagination
      const response = await api.get(endpoint.notification_history, {
        params: {
          sortBy: "date",
          orderBy: "DESC",
          search,
          ...filter,
          sessionId,
          bulk: true, // Flag for bulk download
        },
        withCredentials: true,
      });

      if (response && response.results) {
        // Process the bulk data for CSV export
        const processedData = response.results.map((data, ind) => ({
          No: ind + 1,
          "Alarm Name": data?.notification?.name || "",
          "Site Location": data?.site?.name || "",
          "Device Name": data?.device?.name || "",
          Parameter: data?.parameter?.name || "",
          "Trigger value": data?.value || "",
          "Acknowledged By": data?.acknowledgedBy?.name || "",
          "Acknowledged At": data?.acknowledgedBy ? dayjs(data?.updatedAt).format("DD/MM/YYYY hh:mm:ss a") : "",
          Timestamp: dayjs(data?.createdAt).format("DD/MM/YYYY hh:mm:ss a"),
          "Time Range": `${from} - ${to}`,
        }));

        // Export to CSV immediately
        exportCSV({
          data: processedData,
          filename: `AlarmHistory-bulk-${dayjs().format("YYYY-MM-DD-HH-mm")}`,
        });

        // Log the activity
        const logBody = {
          business: userDetails.business,
          site: userDetails.site,
          activityCategory: "CVS",
          activitySubcategory: "DOWNLOAD",
          activityMsg: `${userDetails.name} (${userRoleFormate[userDetails.role]}) has Downloaded Alarm History (Bulk) - ${response.results.length} records`,
        };
        await api.post(endpoint.create_custom_log, logBody);
      }

      // Cleanup listener after a delay
      setTimeout(() => {
        socket.off("messageResponse", handleProgressUpdate);
      }, 10000);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "An error occurred while downloading the report. Please try again.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  };

  return (
    <div className="settings" style={{ overflow: "hidden" }}>
      <div className="card p-3 m-md-3">
        <div className="d-flex flex-column flex-md-row g-3 align-items-md-center mb-3 justify-content-between">
          <div>
            <label className="az-content-label">MANAGE NOTIFICATION</label>
            <span className="d-block py-2">Alarm Trigger History</span>
          </div>
          <div className="ms-md-auto p-0">
            {userDetails?.role !== userRole.public && (
              <Link to="/create-alarm">
                <Button icon={<FaPlus />} type="primary">
                  Create New Alarm
                </Button>
              </Link>
            )}
          </div>
        </div>
        <hr className="mt-0" />

        {/* filter */}
        <div className="row g-3">
          <div className="col-md-4">
            <label htmlFor="business" className="form-label">
              Business
            </label>
            <Select
              style={{ width: "100%" }}
              size="large"
              // mode={userDetails?.role === userRole.superAdmin ? "multiple" : ""}
              maxTagCount={1}
              value={business || ""}
              onChange={(value) => setFilter((prev) => ({ ...prev, business: value, site: "" }))}
              showSearch={true}
              filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
              placeholder="All Businesses"
              disabled={businessList?.length === 1}
              options={[
                { label: `All Business`, value: "" },
                ...businessList.map((item) => ({ label: `${item.name} (${item.id})`, value: item._id })),
              ]}
              required
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="site" className="form-label">
              Site Location
            </label>
            <Select
              style={{ width: "100%" }}
              showSearch={true}
              filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
              size="large"
              value={site || ""}
              onChange={(value) => setFilter({ ...filter, site: value })}
              options={[
                { label: `All Site Location`, value: "" },
                ...(siteLocations?.map((item) => ({ label: `${item.name}`, value: item._id })) || []),
              ]}
            />
          </div>
          <div className="col-md-5">
            <label htmlFor="site" className="form-label">
              Select Date | Time
            </label>
            <RangePicker
              disabledDate={disabledDate}
              style={{ width: "100%" }}
              presets={{ label: "date" }}
              value={[filter?.from ? dayjs(filter?.from) : "", filter?.to ? dayjs(filter?.to) : ""]}
              showTime={{ format: "HH:mm" }}
              placeholder={["Select Start Date | Time", "Select End Date | Time"]}
              format="YYYY/MM/DD : HH:mm"
              onChange={(e, dateString) => {
                setFilter({
                  ...filter,
                  from: dateString[0],
                  to: dateString[1],
                });
              }}
              size="large"
            />
          </div>
          {/* <div className="col-md-2">
            <label htmlFor="site" className="form-label">
              Search
            </label>
          </div> */}
        </div>
        <div className="d-flex mt-3">
          <Button type="primary" className="ms-md-auto" onClick={getNotificationHistory}>
            Generate
          </Button>
        </div>
        <hr />
        <div>
          <div className="d-flex"></div>

          <div>
            <div className="row">
              <div className="col-md-10"></div>
              <div className="col-md-2 mb-2">
                <Input size="large" onChange={onSearch} placeholder="Search Alarms" value={search} />
              </div>
            </div>

            <LoadingOverlay isLoading={isLoading}>
              <DataTable
                columns={columns}
                dataSource={notifications}
                pagination={{
                  pageSize: limit,
                  current: page,
                  total,
                  showSizeChanger: true,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                  pageSizeOptions: [10, 20, 50],
                  responsive: true,
                }}
                onChange={({ pageSize, current }) => {
                  setLimit(pageSize);
                  setPage(current);
                }}
              />
            </LoadingOverlay>
          </div>

          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              zIndex: "-9999",
              opacity: 0,
            }}
          ></div>
          <div className="text-right mt-3">
            {userDetails?.role !== userRole?.public && (
              <Button
                onClick={handleBulkDownloadCSV}
                disabled={notifications.length === 0}
                className="ms-auto"
                type="primary"
              >
                Download CSV
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlarmHistory;
